<div class="modal-header">
  <h4 class="modal-title">{{ title }}</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()">
  </button>
</div>
<div class="modal-body">
  <ngb-alert *ngIf="alert" [type]="alert.type" (closed)="closeAlert()" class="sticky-top" style="top: 10px;">
    <span [innerHtml]="alert.message"></span>
  </ngb-alert>
  <div class="uploader-and-preview" [class.no-image]="!uploader.queue.length && !currentImageUrl">

    <div *ngIf="uploader.queue.length && !resizeState" class="media">
      <img src="" appImgPreview [image]="uploader.queue[0]?._file" />
    </div>

    <div *ngIf="currentImageUrl && !uploader.queue.length && !resizeState" class="media">
      <img [src]="currentImageUrl">
    </div>
    
    <label class="btn btn-secondary text-white form-label" for="fileupload" (click)="closeAlert()">Choose...</label>

    <input
      type="file"
      ng2FileSelect
      id="fileupload"
      #fileInput
      [style.display]="'none'"
      (change)="fileChangeEvent($event)"
      [uploader]="uploader"
    />

    <image-cropper
      class="image-cropper"
      *ngIf="resizeState"
      [imageChangedEvent]="imageChangedEvent"
      [maintainAspectRatio]="true"
      format="png"
      (imageCropped)="imageCropped($event)"
    ></image-cropper>

  </div>
</div>

<ngb-progressbar
  *ngIf="loading"
  type="success"
  [value]="loadingProgess"
  [striped]="true"
  [animated]="true">
  <i class="text-white">{{ loadingProgess }}%</i>
</ngb-progressbar>
<div class="modal-footer">
  <button 
    *ngIf="uploader.queue[0]?._file"
    type="button"
    class="btn btn-light me-auto"
    [class.me-auto]="!resizeState"
    [class.mr-auto]="resizeState"
    [class.btn-brand-orange]="resizeState"
    [disabled]="loading"
    (click)="toggleResizeState()">
    {{ resizeState ? "Save" : "Resize" }}
  </button>
  <button 
    type="button"
    class="btn btn-light"
    [class.d-none]="resizeState"
    [disabled]="resizeState"
    ngbAutofocus
    (click)="cancel()">
    {{ isResized && !loading ? 'Revert' : 'Cancel' }}
  </button>
  <button 
    type="button" [disabled]="!uploader.queue.length || loading || resizeState"
    class="btn btn-success"
    [class.text-white]="!resizeState"
    [class.d-none]="resizeState"
    (click)="upload()">
      {{ loading ? 'Uploading...' : 'Upload' }}
  </button>
</div>
